<template>
  <x-form
    modal
    :title="$t('Note')"
    variant="medium"
    open
    xhr
    encoding="json"
    method="put"
    :action="`/rest/product_orders/${productId}`"
    :submit-text="$t('Salva')"
    @submit="onSubmit"
    @close="$emit('close')"
  >
    <form-group
      :name="$t('Nota visibile in fattura')"
      :helper-text="
        $t('Puoi inserire qui un breve testo, un numero di riferimento o un codice che verrà riportato in tutte le fatture di rinnovo di questo prodotto.')
      "
    >
      <x-input v-model="value" name="note_cliente" type="text" />
    </form-group>
  </x-form>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import type { ComponentProps } from 'vue-component-type-helpers';
import type XForm from './x-form.vue';

type XFormProps = ComponentProps<typeof XForm>;

interface Props
  extends /* @vue-ignore */ Omit<
    XFormProps,
    | 'title'
    | 'variant'
    | 'open'
    | 'onUpdate:open'
    | 'xhr'
    | 'encoding'
    | 'method'
    | 'action'
    | 'submitText'
    | 'onSubmit'
    | 'modal'
    | 'onClose'
    | 'open'
    | 'onUpdate:open'
  > {
  productId: number;
  customerNote?: string | null;
}

const props = defineProps<Props>();

const emit = defineEmits<{
  (name: 'update:customerNote', value: string): void;
  (name: 'close'): void;
  (name: 'submit'): void;
}>();

const value = ref(props.customerNote ?? '');

function onSubmit() {
  emit('update:customerNote', value.value);
  emit('submit');
  emit('close');
}
</script>
